import React, { useState } from 'react';

const TestProfile: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'account' | 'sports'>('account');

  return (
    <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Test Profile Page</h1>
      
      {/* Tab Navigation */}
      <div style={{
        display: 'flex',
        backgroundColor: 'white',
        borderRadius: '8px 8px 0 0',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        marginBottom: '0',
        overflow: 'hidden',
        border: '2px solid red' // Debug border
      }}>
        <button
          style={{
            flex: 1,
            padding: '1rem 2rem',
            border: 'none',
            backgroundColor: activeTab === 'account' ? 'white' : '#f8f9fa',
            color: activeTab === 'account' ? '#3498db' : '#666',
            fontSize: '1rem',
            fontWeight: '500',
            cursor: 'pointer',
            borderBottom: activeTab === 'account' ? '3px solid #3498db' : '3px solid transparent',
          }}
          onClick={() => setActiveTab('account')}
        >
          Account Information
        </button>
        <button
          style={{
            flex: 1,
            padding: '1rem 2rem',
            border: 'none',
            backgroundColor: activeTab === 'sports' ? 'white' : '#f8f9fa',
            color: activeTab === 'sports' ? '#3498db' : '#666',
            fontSize: '1rem',
            fontWeight: '500',
            cursor: 'pointer',
            borderBottom: activeTab === 'sports' ? '3px solid #3498db' : '3px solid transparent',
          }}
          onClick={() => setActiveTab('sports')}
        >
          Sport Preferences
        </button>
      </div>

      {/* Tab Content */}
      <div style={{
        backgroundColor: 'white',
        padding: '2rem',
        borderRadius: '0 0 8px 8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        border: '2px solid blue' // Debug border
      }}>
        {activeTab === 'account' && (
          <div>
            <h2>Account Information</h2>
            <p>This is the account information tab content.</p>
          </div>
        )}

        {activeTab === 'sports' && (
          <div>
            <h2>Sport Preferences</h2>
            <p>This is the sport preferences tab content.</p>
            <div>
              <label>Sport:</label>
              <select style={{ margin: '0.5rem', padding: '0.5rem' }}>
                <option>Fußball</option>
                <option>Handball</option>
                <option>Basketball</option>
              </select>
            </div>
            <div>
              <label>Verein:</label>
              <select style={{ margin: '0.5rem', padding: '0.5rem' }}>
                <option>Bayern München</option>
                <option>Borussia Dortmund</option>
              </select>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TestProfile;
